// Typ cennika dla pośrednika
export const TEMPLATE_PRICE_LIST_TYPE_ENTREPRENEUR = 'type_entrepreneur';
export const TEMPLATE_PRICE_LIST_TYPE_ENTREPRENEUR_COMPONENT = 'price-list-type-entrepreneur';
export const TEMPLATE_PRICE_LIST_TYPE_ENTREPRENEUR_ID = 1;
export const TEMPLATE_PRICE_LIST_TYPE_ENTREPRENEUR_SHORT_NAME = 'Dla przedsiębiorcy';

// Typ cennika dla biura rachunkowego
export const TEMPLATE_PRICE_LIST_TYPE_ACCOUNTING = 'type_accounting';
export const TEMPLATE_PRICE_LIST_TYPE_ACCOUNTING_COMPONENT = 'price-list-type-accounting';
export const TEMPLATE_PRICE_LIST_TYPE_ACCOUNTING_ID = 2;
export const TEMPLATE_PRICE_LIST_TYPE_ACCOUNTING_SHORT_NAME = 'Dla biura rachunkowego';

// Typ cennika dla biura rachunkowego za usługi marketingowe
export const TEMPLATE_PRICE_LIST_TYPE_MARKETING = 'type_marketing';
export const TEMPLATE_PRICE_LIST_TYPE_MARKETING_COMPONENT = 'price-list-type-marketing';
export const TEMPLATE_PRICE_LIST_TYPE_MARKETING_ID = 3;
export const TEMPLATE_PRICE_LIST_TYPE_MARKETING_SHORT_NAME = 'Za marketing';
